import { useQuery } from '@apollo/client';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { GET_BLOCKING_OBJECTS } from 'lib/gqlSchemes/getBlockingObjects';

const useCheckBlockingOptions = (patientId) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(GET_BLOCKING_OBJECTS, {
    variables: { patientId, careTeamIds: [] },
  });

  const checkBlockingObjects = (onConfirm, onCancel) => {
    if (loading) return;
    if (error) {
      enqueueSnackbar(t('Error fetching blocking objects'), {
        variant: 'error',
      });
      return;
    }

    const blockingObjects = data?.user?.patient?.careTeamBlockingObjects;

    if (
      !blockingObjects?.appointments?.length &&
      !blockingObjects?.requestGroups?.length &&
      !blockingObjects?.patientGroups?.length
    ) {
      onConfirm();
    } else {
      enqueueSnackbar(
        t(
          'There are active appointments or care plans for this user, are you sure to continue?'
        ),
        {
          variant: 'warning',
          autoHideDuration: 6000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
          },
          action: (key) => (
            <>
              <Button
                style={{
                  color: 'white',
                  border: '1px solid white',
                  marginRight: 10,
                }}
                onClick={() => {
                  onConfirm();
                  closeSnackbar(key);
                }}
              >
                {t('Confirm')}
              </Button>
              <Button
                style={{ color: 'white', border: '1px solid white' }}
                onClick={() => {
                  onCancel();
                  closeSnackbar(key);
                }}
              >
                {t('Cancel')}
              </Button>
            </>
          ),
        }
      );
    }
  };

  return { checkBlockingObjects };
};

export default useCheckBlockingOptions;
